export default {"src":"/_next/static/media/q.1923871e.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};